import { useTranslation } from 'react-i18next';
import type { ScopeFlag } from '@hc/shared';
import { Badge, type BadgeVariant } from './badge.js';

// Per-entity data-coverage indicator. Semantic mapping onto the four
// allowed badge variants — never invent a 5th.
//   full                       positive  (confirmed full disclosure)
//   scoped_ixbrl_only          accent    (selected / requires attention)
//   scoped_financial_only      neutral   (identity resolution required)
//   screener_only              neutral   (basic identity only)
//
// We deliberately don't use --alert here — limited scope is honest
// reporting of data availability, not a regression or error.
const SCOPE_VARIANT: Record<ScopeFlag, BadgeVariant> = {
  full: 'positive',
  scoped_ixbrl_only: 'accent',
  scoped_financial_only: 'neutral',
  screener_only: 'neutral',
};

export function ScopeBadge({ scope }: { scope: ScopeFlag }) {
  const { t } = useTranslation();
  return (
    <span title={t(`scope.${scope}`)}>
      <Badge variant={SCOPE_VARIANT[scope]}>{t(`scope.${scope}`)}</Badge>
    </span>
  );
}
